import request from '@/utils/request'

export const getSuppliers = (params, config = {}) => request.get('/accounting/suppliers', { params, ...config })

export const createSupplier = data => request.post('/accounting/suppliers', data)

export const getSupplier = id => request.get(`/accounting/suppliers/${id}`)

export const updateSupplier = (id, data) => request.put(`/accounting/suppliers/${id}`, data)
